import { render, staticRenderFns } from "./selectGoods.vue?vue&type=template&id=1561252b&"
import script from "./selectGoods.vue?vue&type=script&lang=js&"
export * from "./selectGoods.vue?vue&type=script&lang=js&"
import style0 from "./selectGoods.vue?vue&type=style&index=0&id=1561252b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports